import { InvoiceComplexity } from "../api/generated"

export function calculateComplexityFromLineItems(lineItems = []) {
  const po_count = lineItems.filter(l => l.purchase_order_line_id != null).length

  let complexity = InvoiceComplexity.NON_PO
  switch (po_count) {
    case 0: {
      complexity = InvoiceComplexity.NON_PO
      break
    }
    case 1: {
      complexity = InvoiceComplexity.SINGLE_PO
      break
    }
    default: {
      complexity = InvoiceComplexity.MULTI_PO
      break
    }
  }
  return complexity
}
